export default {
  'media.title': 'Manage Media',
  'media.categories': 'Categories',
  'media.fileName': 'File name',
  'media.document': 'Document',
  'media.fileType': 'File type',
  'media.fileTypeClassification': 'File type classification',
  'media.fileTypeClassification.unknown': 'Unknown',
  'media.fileTypeClassification.image': 'Image',
  'media.fileTypeClassification.video': 'Video',
  'media.fileTypeClassification.pdf': 'PDF',
  'media.fileTypeClassification.word': 'Word',
  'media.fileTypeClassification.excel': 'Excel',
  'media.fileTypeClassification.powerPoint': 'PowerPoint',
  'media.fileTypeClassification.microsoftProject': 'Microsoft Project',
  'media.fileTypeClassification.text': 'Text',
  'media.fileTypeClassification.xml': 'XML',
  'media.fileTypeClassification.html': 'HTML',
  'media.fileTypeClassification.json': 'JSON',
  'media.fileTypeClassification.zip': 'ZIP',
  'media.fileTypeClassification.audio': 'Audio',
  'media.fileTypeClassification.rar': 'RAR',
  'media.fileTypeClassification.font': 'Font',
  'media.fileTypeClassification.textCsv': 'CSV',
  'media.fileTypeClassification.androidApk': 'Android APK',
  'media.fileTypeClassification.exeFile': 'EXE',
  'media.fileTypeClassification.parquetFile': 'Parquet',
  'media.fileTypeClassification.outlookMessage': 'Outlook Message',
  'media.fileTypeClassification.markdown': 'Markdown',
  'media.ownerType': 'Owner type',
  'media.ownerType.generic': 'Generic',
  'media.ownerType.app': 'App',
  'media.ownerType.process': 'Process',
  'media.ownerType.chat': 'Chat',
  'media.size': 'Size',
  'media.eTag': 'eTag',
  'media.ownerDisplay': 'Owner (display)',
  'media.tags': 'Tags',
};
